import axios from 'axios'

export const FuelPriceApi = {
    // Rota baz tarihi seçim listesi: tarih + o güne ait mazot fiyatı.
    async List(params){
        const response = await axios.get('/api/fuelprice/list',{ params })
        return response
    }
}
